import { motion } from "framer-motion";
import { Star } from "lucide-react";

// Grades 1-3: Kiko walks along a little path, one step per question, towards the star at the end.
export default function KikoPath({ current, total }) {
  if (!total) return null;
  const pct = Math.min(100, (current / total) * 100);
  return (
    <div className="relative mt-3 h-14" data-testid="kiko-path">
      <div className="absolute left-4 right-8 top-1/2 -translate-y-1/2 h-2 rounded-full bg-amber-100 border-2 border-dashed border-amber-400" />
      <div className="absolute left-4 right-8 top-1/2 -translate-y-1/2 flex justify-between">
        {Array.from({ length: total + 1 }).map((_, i) => (
          <span key={i} className={`w-2 h-2 rounded-full ${i <= current ? "bg-green-500" : "bg-amber-300"}`} />
        ))}
      </div>
      <Star className="absolute right-0 top-1/2 -translate-y-1/2 text-yellow-400 drop-shadow" size={30} fill="currentColor" data-testid="kiko-path-star" />
      <div className="absolute left-4 right-8 top-0 bottom-0">
        <motion.img src="/mascot/kiko.png" alt="" draggable={false} className="absolute -top-1 w-11 -ml-5 select-none"
          animate={{ left: `${pct}%`, y: [0, -6, 0] }} transition={{ left: { type: "spring", stiffness: 90, damping: 14 }, y: { duration: 0.5 } }}
          data-testid="kiko-path-kiko" />
      </div>
    </div>
  );
}
